var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"successShared"},[_c('Ok'),_c('span',{staticClass:"linkCopied"},[_vm._v("Link copied")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }